import { render, staticRenderFns } from "./AuthHandler.vue?vue&type=template&id=88144eae&scoped=true&lang=pug&"
import script from "./AuthHandler.vue?vue&type=script&lang=js&"
export * from "./AuthHandler.vue?vue&type=script&lang=js&"
import style0 from "./AuthHandler.scss?vue&type=style&index=0&id=88144eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88144eae",
  null
  
)

export default component.exports